module.exports = __webpack_public_path__ + "static/HERMES_system-1153458fd8e8ddce13a5f9fef38c899b.jpg";